import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FullModeService } from 'src/app/services/full-mode.service';


declare var jQuery: any;
@Component({
  selector: 'app-revolution-slider',
  templateUrl: './revolution-slider.component.html',
  styleUrls: ['./revolution-slider.component.scss']
})
export class RevolutionSliderComponent implements OnInit, AfterViewInit {
  constructor(
    public route:ActivatedRoute,
    public translateService:TranslateService,
    public router:Router,
    public fullModeService:FullModeService
  ) { }

  ngOnInit(): void { }
  ngAfterViewInit(): void {
    jQuery(document).ready(function() {
      jQuery('#rev_slider_2_1').show().revolution({
      jsFileLocation: "js/",
      sliderLayout: "fullwidth",
      visibilityLevels: "1240,1024,778,480",
      gridwidth: "1440,1024,778,480",
      gridheight: "789,600,700,650",
      spinner: "spinner0",
      editorheight: "789,600,700,650",
      responsiveLevels: "1240,1024,778,480",
      disableProgressBar: "on",
      navigation: {
          onHoverStop: false
      },
      parallax: {
          levels: [5, 10, 15, 20, 25, 30, 35, 40, 45, 46, 47, 48, 49, 50, 51, 30],
          type: "mouse",
          origo: "slidercenter",
          speed: 0
      },
      fallbacks: {
          allowHTML5AutoPlayOnAndroid: true
      },
  });
  })
  }

  redirectToDownload(){
    if(this.fullModeService.fullMode==false){
      window.open('https://creator.se2.tech/#/?fullMode=false', '_blank');
    }else{
      window.open('https://creator.se2.tech/#/', '_blank');
    }
  }
}
